import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {usePrices} from '../hooks/usePrices.ts';
import {useParams} from "react-router-dom";

export const ReloadRecordsButton = () => {

    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('Product id is not defined')
    }

    const {fetchRecords} = usePrices(productId);
    
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};